import * as React from 'react';
import { toast } from 'react-toastify';

import { CopyOutlined as FileCopyOutlined, LinkOutlined } from '@ant-design/icons';
import { Table, Button } from 'antd';

import { CHECKOUT_ELEMENTS_URL } from 'settings';
import Truncate from 'v2/components/Shared/TruncateText';
import type { ProductOffer } from 'v2/interfaces/product';

type PricesListProps = {
  offer: ProductOffer;
};

type ProductPrice = ProductOffer['prices'][0];

function PricesList({ offer }: PricesListProps) {
  function mountOfferLink(price: ProductPrice) {
    return `${CHECKOUT_ELEMENTS_URL}/${offer.key}?currency=${price.currency.code}`;
  }

  function copyLinkToClipboard(link: string) {
    navigator.clipboard.writeText(link);
    toast.success('Link copiado para a área de transferência');
  }

  function mountOfferCurrency(price: ProductPrice) {
    return `${price.currency.code} (${price.currency.name})`;
  }

  if (!offer.prices?.length) return null;

  const columns = [
    {
      title: 'Moeda',
      dataIndex: 'currency',
      key: 'currency',
      render: (_: any, price: ProductPrice) => (
        <span className='whitespace-nowrap' id={`links-modal-offer-currency-${price.currency.code}`}>
          <Truncate count={25}>{mountOfferCurrency(price)}</Truncate>
        </span>
      )
    },
    {
      title: 'Valor',
      dataIndex: 'value',
      key: 'value',
      width: 112,
      render: (_: any, price: ProductPrice) => (
        <span id={`links-modal-offer-price-${price.currency.code}`}>
          {price.value.toLocaleString('pt-BR', {
            style: 'currency',
            currency: price.currency.code
          })}
        </span>
      )
    },
    {
      title: 'Página de pagamento (Checkout Sun)',
      dataIndex: 'link',
      key: 'link',
      width: 300,
      render: (_: any, price: ProductPrice) => (
        <div className='border-border flex items-center gap-2 border py-1 pr-2 pl-[13px]'>
          <LinkOutlined style={{ fontSize: 18 }} />
          <a
            className='max-w-[203px] overflow-hidden text-[14px] leading-6 text-ellipsis whitespace-nowrap text-black hover:underline'
            id={`links-modal-offer-link-${price.currency.code}`}
            href={mountOfferLink(price)}
            target='_blank'
            rel='noreferrer'
          >
            {mountOfferLink(price)}
          </a>
          <Button
            type='text'
            id={`links-modal-copy-button-${price.currency.code}`}
            size='small'
            icon={<FileCopyOutlined style={{ fontSize: 18 }} />}
            onClick={() => copyLinkToClipboard(mountOfferLink(price))}
          />
        </div>
      )
    }
  ];

  return <Table size='small' dataSource={offer.prices} columns={columns} rowKey='id' pagination={false} />;
}

export { PricesList };
